// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__162rm","footer":"styles_footer__kFFrj","passCodeTooltip":"styles_passCodeTooltip__3vU1W"};